// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ERnwp","newExpiryDate":"styles_newExpiryDate__2LWfZ","footer":"styles_footer__trYaI"};